module.exports = __webpack_public_path__ + "static/media/transferencia_icon.f59736b5.png";